import { PlusIcon, RectangleStackIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import UserProfile from "src/components/Users/UserProfile";
import { classNames } from "src/helpers/classNames";
import { formatName } from "src/helpers/formatName";

const BubbleIconList = ({ data, type = "user", className = "", rounded = true, add_icon = false }) => {
  const [members, setMembers] = useState([]);
  const [invalidImage, setInvalidImage] = useState(false);

  useEffect(() => {
    if (data?.length > 0) {
      setMembers(data.slice(0, 3));
    } else {
      setMembers([]);
    }
  }, [data]);

  return (
    <>
      <div className={`flex items-center justify-center ${className}`}>
        <div className="flex items-center -space-x-2">
          {add_icon && (
            <div
              title="add"
              className={classNames("z-30 flex h-[27px] w-[27px] cursor-pointer items-center justify-center border border-white bg-gray-200 text-gray-500 hover:bg-gray-200", rounded ? "rounded-full" : "rounded-sm")}>
              <span className="text-lg leading-none text-black">
                <PlusIcon className="h-4 w-4" />
              </span>
            </div>
          )}

          {type === "user" ? (
            members &&
            members?.map((user) => {
              return (
                <div
                  key={user?._id || user?.id}
                  className={classNames("z-20 h-6 w-6 overflow-hidden ring-2 ring-white ring-offset-0", rounded ? "rounded-full" : "rounded-sm")}>
                  <UserProfile
                    user={user}
                    size="sm"
                  />
                </div>
              );
            })
          ) : (
            <>
              {members?.map((item, index) => (
                <div
                  key={item?._id || item?.id}
                  style={{ height: `${25 - index * 2}px`, width: `${25 - index * 2}px`, zIndex: members?.length - index }}
                  className={classNames("z-20 overflow-hidden border border-gray-50 ring-offset-0", rounded ? "rounded-full" : "rounded-sm")}>
                  {invalidImage || !item?.image ? (
                    <div className={classNames("flex h-full w-full flex-shrink-0 items-center justify-center overflow-hidden bg-gray-200 text-xs uppercase text-gray-900", rounded ? "rounded-full" : "rounded-sm")}>{formatName(item?.name, item?.email)}</div>
                  ) : (
                    <div className={classNames("relative h-full w-full flex-shrink-0 overflow-hidden", rounded ? "rounded-full" : "rounded-sm")}>
                      <img
                        className={classNames("h-full w-full bg-white object-contain", "opacity-100 transition-opacity duration-150")}
                        src={item?.image}
                        alt="data-image"
                        onError={() => setInvalidImage(true)}
                      />
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
        </div>
        <div className="flex flex-shrink-0 items-center justify-center text-sm font-medium text-gray-400">
          {data?.length > 0 ? (
            data?.length === 1 ? (
              <div className="max-w-[min(100px,60vw)] truncate text-center sm:ml-2 sm:text-left">{data?.[0]?.name || (data?.[0]?.first_name ? `${data[0].first_name || ""}` : "")}</div>
            ) : data?.length > 3 ? (
              <div className="text-center sm:ml-2 sm:text-left">
                +{data.length - 3} other{data.length - 3 > 1 ? "s" : ""}
              </div>
            ) : (
              <div className="text-center sm:ml-2 sm:text-left">
                {data?.length} {type || "user"}
                {data?.length > 1 ? "s" : ""}
              </div>
            )
          ) : type === "user" ? (
            `No ${type || "user"}s`
          ) : (
            <div className="flex flex-col items-center gap-1 font-medium text-gray-300 transition-all duration-100 sm:flex-row sm:gap-[2px] md:gap-1">
              <RectangleStackIcon className="h-5 w-5" />
              <span>0 {type}s</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BubbleIconList;
